import { EntityBase } from "./EntityBase";
import { State } from "./State";
import { Utility } from "./Utility";
import { Pair } from "../obj/Pair";

export class Company extends EntityBase {
    name: string = null!;
    active: boolean = false;
    isSupplier: boolean = false;
    marketType: string = null!;
    website: string = null!;
    utilities: Utility[] = null!;
    autoTransactionsOn: boolean = true;
    taxExempt: boolean | null = null;
    federalTaxID: string = null!;
    taxExemptCertificateDocument: Pair = null!;
    state: State = null!;
    city: string = null!;
    addressLine1: string = null!;
    addressLine2: string = null!;
    zip: string = null!;
    phone: string = null!;
    logo: string | null = null;
    enrollEmail: string | null = null;
    enrollCCEmail: string | null = null;
}
